import { Helmet } from "react-helmet";

import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Footer from "components/Footer";
import InfluencerFeaturesSection from "./InfluencerFeaturesSection";
import FeaturesSection from "./FeaturesSection";
import PagentisNotJustSocialMedia from "./PagentisNotJustSocialMedia";
import Aboutus from "./Aboutus";
import TheFirstKind from "./TheFirstKind";
import Header from "../../components/Header";

// Animation variants for page sections
const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { 
      duration: 0.6,
      ease: "easeOut"
    }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};

export default function WebDesignPage() {
  const [scrolled, setScrolled] = useState(false);
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      setScrollY(offset);
      
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  
  const className = scrolled ? "scrolled" : "";

  return (
    <>
      <Helmet>
        <title>Pagent</title>
        <meta
          name="description"
          content="Join Pagent, the ultimate social gaming app. Compete in challenges, connect with new people, and showcase your talents. Climb the leaderboard and become an influencer in categories like Karaoke, Dance, Makeup, and more."
        />
        <link rel="icon" type="image/x-icon" href="/images/pagent-logo-icon.png"/>
        <style>
          {`
            body {
              text-rendering: optimizeLegibility;
              -webkit-font-smoothing: antialiased;
              -moz-osx-font-smoothing: grayscale;
            }
            
            .text-shadow-sm {
              text-shadow: 0 1px 2px rgba(0,0,0,0.1);
            }
            
            html {
              scroll-behavior: smooth;
            }
          `}
        </style>
      </Helmet>

      <motion.div
        initial="hidden"
        animate="visible"
        variants={staggerContainer}
        className="overflow-hidden"
      >
        <Header className={className} />
        
        <motion.div variants={fadeInUp}>
          <FeaturesSection />
        </motion.div>
        
        <motion.div 
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <PagentisNotJustSocialMedia />
        </motion.div>
        
        <motion.div 
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <Aboutus />
        </motion.div>
        
        <motion.div 
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <InfluencerFeaturesSection />
        </motion.div>

        <motion.div 
          variants={fadeInUp}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
        >
          <TheFirstKind />
        </motion.div>
        
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
        >
          <Footer />
        </motion.div>
      </motion.div>
      
      <AnimatePresence>
        {scrollY > 300 && (
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 20 }}
            transition={{ duration: 0.3 }}
            className="fixed bottom-5 right-5 z-50"
            onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            style={{ cursor: 'pointer' }}
          >
            <div className="bg-gradient-to-r from-yellow-400 to-yellow-600 rounded-full p-3 shadow-lg">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M18 15L12 9L6 15" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
}
